// importeer hier alle scripts die je maakt

import "./utils/favicon.js";
import "./utils/boxSizing.js";
import "./alpine/alpine.js";
import "./animations/animations.js";
import "./components/swiper.js";
import "./components/scrollPin.js";

// Lenis smooth-scroll is admin2win-only — dynamically imported so it never loads
// on the ETS site.
if (document.documentElement.dataset.brand === "admin2win") {
    import("./animations/lenis.js");
}
import "./components/language-switcher.js";
import "./vendor/iubenda.js";
// import "./vendor/recaptcha.js";
import "./vendor/ga-slug.js";
import "./helpers/lazyImgs.js";
import "./helpers/equalHeights.js";
import "./helpers/columnPadding.js";
import "./helpers/connectCards.js";
import "./helpers/formPlaceholders.js";

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]", {});
Fancybox.bind("[data-fancybox='gallery']", {});
